<img *ngFor="let star of stars" [src]="star" alt="star">